import { apiService } from './api';
import { 
  DocumentResponse, 
  DocumentCreateRequest, 
  DocumentUpdateRequest, 
  DocumentFilterResponse,
  PageResponse 
} from '../types/api';

export class DocumentService {
  // Récupérer tous les documents avec pagination et filtres
  async getAllDocuments(
    page: number = 0,
    size: number = 8,
    category?: 'OFFICIAL' | 'TD' | 'CORRECTION' | 'EXAMEN' | 'DEVOIR',
    level?: string,
    subject?: string,
    type?: 'PDF' | 'DOCX' | 'XLSX',
    searchTerm?: string,
    year?: string
  ): Promise<PageResponse<DocumentResponse>> {
    const params: any = { page, size };
    if (category) params.category = category;
    if (level) params.level = level;
    if (subject) params.subject = subject;
    if (type) params.type = type;
    if (searchTerm) params.searchTerm = searchTerm;
    if (year) params.year = year; // ex: "2022-2023" ou "2022,2023"
    
    return apiService.get<PageResponse<DocumentResponse>>('/documents', params);
  }

  // Récupérer les filtres disponibles
  async getFilters(): Promise<DocumentFilterResponse> {
    return apiService.get<DocumentFilterResponse>('/documents/filters');
  }

  // Récupérer un document par ID
  async getDocumentById(id: number): Promise<DocumentResponse> {
    return apiService.get<DocumentResponse>(`/documents/${id}`);
  }

  // Créer un nouveau document
  async createDocument(request: DocumentCreateRequest): Promise<DocumentResponse> {
    const formData = new FormData();
    formData.append('title', request.title);
    formData.append('type', request.type);
    formData.append('category', request.category);
    
    if (request.level) formData.append('level', request.level);
    if (request.subject) formData.append('subject', request.subject);
    if (request.description) formData.append('description', request.description);
    if (request.year) formData.append('year', request.year);
    if (request.file) formData.append('file', request.file);

    return apiService.upload<DocumentResponse>('/documents', formData);
  }

  // Mettre à jour un document
  async updateDocument(id: number, request: DocumentUpdateRequest): Promise<DocumentResponse> {
    const formData = new FormData();
    formData.append('title', request.title);
    formData.append('type', request.type);
    formData.append('category', request.category);
    
    if (request.level) formData.append('level', request.level);
    if (request.subject) formData.append('subject', request.subject);
    if (request.description) formData.append('description', request.description);
    if (request.year) formData.append('year', request.year);
    if (request.file) formData.append('file', request.file);

    return apiService.uploadPut<DocumentResponse>(`/documents/${id}`, formData);
  }

  // Supprimer un document
  async deleteDocument(id: number): Promise<void> {
    return apiService.delete(`/documents/${id}`);
  }

  // Télécharger un document
  async downloadDocument(id: number): Promise<Blob> {
    return apiService.download(`/documents/download/${id}`);
  }
}

export const documentService = new DocumentService(); 